<template>
  <div class="otherTime">
    <p>
      <span>
        <el-radio v-model="data.time" label="全天">全天（8点~18点）</el-radio>
      </span>
      <span>
        <el-radio v-model="data.time" label="上午">上午（8点~12点）</el-radio>
      </span>
      <span>
        <el-radio v-model="data.time" label="下午">下午（14点~18点）</el-radio>
      </span>
      <span>
        <el-radio v-model="data.time" label="晚上">晚上（18点~22点）</el-radio>
      </span>
    </p>
    <!-- <el-autocomplete v-if="$parent.resourceType=='officialInvitation'" v-model="data.date.value1" 
      :fetch-suggestions="querySearch" clearable placeholder="请输入城市名称" :key="index" 
      @select="handleSelect($event,data.date)" value-key="value1" size="mini" style='width:125px' :disabled="data.date.dis"
      slot="reference">
    <template slot-scope="{ item }">
      <div class="name">{{item.citynamecn}}({{item.countrynamecn}})</div>
    </template>
    </el-autocomplete>    -->
    <p>
      <el-radio v-model="data.time" label="other">
        <span style="width: 0px">&nbsp;</span>
      </el-radio>
      <el-select v-model="data.onehour" placeholder="时" size="mini" style="width: 65px" @change="checkThisRadioOfficialInvitation(data)">
        <el-option v-for="item in 24" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      点
      <el-select v-model="data.onemin" placeholder="分" size="mini" style="width: 65px" @change="checkThisRadioOfficialInvitation(data)">
        <el-option v-for="item in 60" :key="item" :label="item - 1" :value="item - 1"></el-option>
      </el-select>
      分
      <b>至&nbsp;</b>
      <el-select v-model="data.twohour" placeholder="时" size="mini" style="width: 65px" @change="checkThisRadioOfficialInvitation(data)">
        <el-option v-for="item in 24" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      点
      <el-select v-model="data.twomin" placeholder="分" size="mini" style="width: 65px" @change="checkThisRadioOfficialInvitation(data)">
        <el-option v-for="item in 60" :key="item" :label="item - 1" :value="item - 1"></el-option>
      </el-select>
      分
      <b class="el-icon-close" @click="deleteOfficialInvitationTime(index)" v-if="index > 0"></b>
    </p>
  </div>
</template>

<script>
export default {
  props:{
    data:{
      type:Object,
      default:()=>{return {}}
    },
    index:{
      type:Number,
      default:0,
    },
  },
  methods:{
    deleteOfficialInvitationTime(index){
      this.$emit("deleteOfficialInvitationTime",index)
    }
  }
}
</script>

<style lang="scss" scoped>
.otherTime{
  >p{
    margin-left: 0.1rem;
    margin-bottom: 0.1rem;
    /deep/ .el-radio{
      margin-right: 0.05rem !important;
    }
  }
  >p:last-child{
    /deep/ .el-radio__label{
      padding-left: 0 !important;
    }
  }
}
</style>